import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../assets/img/logo.jpg'
import _imports_1 from '../../../assets/img/icons/search.svg'
import _imports_2 from '../../../assets/img/icons/cart.svg'
import _imports_3 from '../../../assets/img/icons/setting.svg'
import _imports_4 from '../../../assets/img/icons/menu-bar.svg'


const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row align-items-center" }
const _hoisted_3 = { class: "col-xl-6 col-lg-5 col-md-8 col-3" }
const _hoisted_4 = { class: "header-left d-flex align-items-center" }
const _hoisted_5 = { class: "col-xl-6 col-lg-7 col-md-4 col-9" }
const _hoisted_6 = { class: "header-right d-flex align-items-center justify-content-end" }
const _hoisted_7 = { class: "navbar-nav d-flex flex-row md-none" }
const _hoisted_8 = { class: "nav-item" }
const _hoisted_9 = { class: "dropdown-menu position-absolute bg-white start-0 rounded-1" }
const _hoisted_10 = { class: "nav-item fs-14" }
const _hoisted_11 = { class: "nav-item fs-14" }
const _hoisted_12 = { class: "nav-item fs-14" }
const _hoisted_13 = { class: "nav-item fs-14" }
const _hoisted_14 = { class: "nav-item fs-14" }
const _hoisted_15 = { class: "nav-item fs-14" }
const _hoisted_16 = { class: "nav-item fs-14" }
const _hoisted_17 = { class: "nav-item fs-14" }
const _hoisted_18 = { class: "nav-item fs-14" }
const _hoisted_19 = { class: "nav-item" }
const _hoisted_20 = { class: "nav-item" }
const _hoisted_21 = { class: "nav-item" }
const _hoisted_22 = { class: "option-item" }
const _hoisted_23 = { class: "option-item" }
const _hoisted_24 = { class: "profile-dropdown" }
const _hoisted_25 = {
  class: "dropdown-toggle text-start text-black-emphasis d-flex align-items-center p-0 position-relative bg-transparent border-0 transition lh-1",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_26 = ["src"]
const _hoisted_27 = { class: "md-none" }
const _hoisted_28 = { class: "d-block fw-bold text-title" }
const _hoisted_29 = { class: "text-paragraph fs-14" }
const _hoisted_30 = { class: "dropdown-menu top-1 shadow-none border-0" }
const _hoisted_31 = { class: "list-style" }
const _hoisted_32 = { class: "fs-14 d-block transition" }
const _hoisted_33 = { class: "fs-14 d-block transition" }
const _hoisted_34 = { class: "fs-14 d-block transition" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_SearchModal = _resolveComponent("SearchModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", {
      id: "header",
      class: _normalizeClass(['header-area style-one bg-white w-100', { sticky: _ctx.isSticky }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_router_link, {
                to: "/",
                class: "logo"
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createElementVNode("img", {
                    class: "logo-light logo-custom",
                    src: _imports_0,
                    alt: "Image"
                  }, null, -1),
                  _createElementVNode("img", {
                    class: "logo-dark logo-custom",
                    src: _imports_0,
                    alt: "Image"
                  }, null, -1)
                ]))]),
                _: 1
              }),
              _cache[2] || (_cache[2] = _createElementVNode("form", {
                action: "#",
                class: "search-area position-relative w-100 md-none"
              }, [
                _createElementVNode("input", {
                  type: "search",
                  placeholder: "Search Your Product",
                  class: "w-100 bg_ash border-0 rounded-1 fs-14 text-black"
                }),
                _createElementVNode("button", {
                  type: "submit",
                  class: "bg-transparent border-0 position-absolute top-0 end-0 h-100 pt-0 py-0 px-4"
                }, [
                  _createElementVNode("img", {
                    src: _imports_1,
                    alt: "Image"
                  })
                ])
              ], -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("ul", _hoisted_7, [
                _createElementVNode("li", _hoisted_8, [
                  _cache[12] || (_cache[12] = _createElementVNode("a", {
                    href: "javascript:void(0)",
                    class: "dropdown-toggle nav-link"
                  }, " Shop ", -1)),
                  _createElementVNode("ul", _hoisted_9, [
                    _createElementVNode("li", _hoisted_10, [
                      _createVNode(_component_router_link, {
                        to: "/shop-right-sidebar",
                        class: "nav-link"
                      }, {
                        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                          _createTextVNode(" Shop Right Sideabr ", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_11, [
                      _createVNode(_component_router_link, {
                        to: "/shop-left-sidebar",
                        class: "nav-link"
                      }, {
                        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                          _createTextVNode(" Shop left Sideabr ", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_12, [
                      _createVNode(_component_router_link, {
                        to: "/shop-grid",
                        class: "nav-link"
                      }, {
                        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                          _createTextVNode(" Shop Grid ", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_13, [
                      _createVNode(_component_router_link, {
                        to: "/shop-details",
                        class: "nav-link"
                      }, {
                        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                          _createTextVNode(" Shop Details ", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_14, [
                      _createVNode(_component_router_link, {
                        to: "/cart",
                        class: "nav-link"
                      }, {
                        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                          _createTextVNode(" Cart ", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_15, [
                      _createVNode(_component_router_link, {
                        to: "/wishlist",
                        class: "nav-link"
                      }, {
                        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                          _createTextVNode(" Wishlist ", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_16, [
                      _createVNode(_component_router_link, {
                        to: "/checkout",
                        class: "nav-link"
                      }, {
                        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                          _createTextVNode(" Checkout ", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_17, [
                      _createVNode(_component_router_link, {
                        to: "/login",
                        class: "nav-link"
                      }, {
                        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                          _createTextVNode(" Login ", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_18, [
                      _createVNode(_component_router_link, {
                        to: "/terms-conditions",
                        class: "nav-link"
                      }, {
                        default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                          _createTextVNode(" Terms & Conditions ", -1)
                        ]))]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _createElementVNode("li", _hoisted_19, [
                  _createVNode(_component_router_link, {
                    to: "/offers",
                    class: "nav-link"
                  }, {
                    default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                      _createTextVNode(" Offer ", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_20, [
                  _createVNode(_component_router_link, {
                    to: "/faq",
                    class: "nav-link"
                  }, {
                    default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                      _createTextVNode("FAQ", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_21, [
                  _createVNode(_component_router_link, {
                    to: "/contact",
                    class: "nav-link"
                  }, {
                    default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                      _createTextVNode(" Contact ", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              _cache[19] || (_cache[19] = _createElementVNode("div", { class: "option-item d-md-none" }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "search-btn bg-transparent border-0 p-0 position-relative",
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#searchModal"
                }, [
                  _createElementVNode("img", {
                    src: _imports_1,
                    alt: "Image",
                    class: "position-relative top-1"
                  })
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_component_router_link, {
                  to: "/cart",
                  class: "shopcart position-relative d-inline-block"
                }, {
                  default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                    _createElementVNode("img", {
                      src: _imports_2,
                      alt: "Image"
                    }, null, -1),
                    _createElementVNode("span", { class: "position-absolute rounded-circle text-center top-0 end-0 text-white fw-medium" }, " 2 ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("button", _hoisted_25, [
                    _createElementVNode("img", {
                      src: _ctx.user?.avatar || _ctx.defaultAvatar,
                      alt: "admin"
                    }, null, 8, _hoisted_26),
                    _createElementVNode("span", _hoisted_27, [
                      _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.user ? (_ctx.user.first_name + ' ' + (_ctx.user.last_name || '')) : 'Guest'), 1),
                      _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.user ? (_ctx.user.username || 'User') : 'Please Login'), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("ul", _hoisted_31, [
                      _createElementVNode("li", _hoisted_32, [
                        _createVNode(_component_router_link, {
                          to: "/my-profile",
                          class: "d-block"
                        }, {
                          default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                            _createTextVNode(" My Profile ", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("li", _hoisted_33, [
                        _createVNode(_component_router_link, {
                          to: "/system-settings",
                          class: "d-block"
                        }, {
                          default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                            _createTextVNode(" Settings ", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("li", _hoisted_34, [
                        _createElementVNode("a", {
                          href: "#",
                          class: "d-block",
                          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleLogout && _ctx.handleLogout(...args)), ["prevent"]))
                        }, " Logout ")
                      ])
                    ])
                  ])
                ])
              ]),
              _cache[20] || (_cache[20] = _createElementVNode("div", { class: "option-item me-lg-0 d-none" }, [
                _createElementVNode("a", {
                  class: "settings-toggler d-flex flex-column justify-content-center align-items-center",
                  "data-bs-toggle": "offcanvas",
                  href: "#settingsBar",
                  role: "button",
                  "aria-controls": "settingsBar"
                }, [
                  _createElementVNode("img", {
                    src: _imports_3,
                    alt: "Image"
                  })
                ])
              ], -1)),
              _cache[21] || (_cache[21] = _createElementVNode("div", { class: "option-item d-lg-none" }, [
                _createElementVNode("a", {
                  class: "navbar-toggler d-flex flex-column justify-content-center align-items-center rounded-1",
                  "data-bs-toggle": "offcanvas",
                  href: "#navbarOffcanvas",
                  role: "button",
                  "aria-controls": "navbarOffcanvas"
                }, [
                  _createElementVNode("img", {
                    src: _imports_4,
                    alt: "Menu Bar"
                  })
                ])
              ], -1))
            ])
          ])
        ])
      ])
    ], 2),
    _createVNode(_component_SearchModal)
  ], 64))
}